export default function ContactForm() {
    return (
      <div className="darkContainer">
      <section id='contact'>
      <div>
        <h3>Mail :</h3>
        <p><a href="mailto:trapu.paolo@gmail.com">trapu.paolo@gmail.com</a></p>

        <h3>Téléphone :</h3>
        <p>07.68.45.91.04</p>

      </div>
      </section>
      </div>
    )
  }
